import { refreshRecaptcha } from './recaptcha';
import axiosInstance, { endpoints } from './axios';

export const uploadFile = async <T extends File | File[]>(
  file: T
): Promise<T extends File[] ? string[] : string> => {
  const formData = new FormData();
  console.log(file);
  if (Array.isArray(file)) {
    file.forEach((f) => {
      formData.append('images', f);
    });
  } else {
    formData.append('images', file);
  }

  await refreshRecaptcha();
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(endpoints.file.upload, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        resolve(res.data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
